import {BaseSearchDTO} from './baseSearchDTO.interface';

export interface AttribSearchDTO extends BaseSearchDTO
{
  filters?: {
    code?: string;
  }
}
